export default {
  icons: [],
  selectItems: []
};
